import { render, staticRenderFns } from "./ArticleHome.vue?vue&type=template&id=4fd1fc1e"
import script from "./ArticleHome.vue?vue&type=script&lang=js"
export * from "./ArticleHome.vue?vue&type=script&lang=js"
import style0 from "./ArticleHome.vue?vue&type=style&index=0&id=4fd1fc1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports